var FormHelper = function(root) {
    this.root = root || document;
}

FormHelper.prototype.getInput = function(type, name) {
    return this.root.querySelector('[data-' + type + '="' + name + '"]');
}

FormHelper.prototype.getInputByAnetName = function(name) {
    return this.getInput("anet-name", name);
}

FormHelper.prototype.getInputbyParisName = function(name) {
    return this.getInput("paris-name", name);
}


FormHelper.prototype.getInputReal = function(type, name) {
    return this.root.querySelector('[data-' + type + '="' + name + '"]');
}


FormHelper.prototype.getValue = function(type, name) {
    var value = null;

    var element = this.getInputReal(type, name);

    if (element) {
        value = element.value;
    }

    return value;
}

FormHelper.prototype.getValueByParisName = function(name) {
    return this.getValue("paris-name", name);
}

FormHelper.prototype.getValueByAnetName = function(name) {
    return this.getValue("anet-name", name);
}


FormHelper.prototype.setValue = function(input, value) {
    if (input.tagName === "select") {
        input.querySelector('[value="' + value + '"]').selected = true;
    } else {
        input.value = value;
    }

    return input.value === value;
}


FormHelper.prototype.setValueByParisName = function(name, value) {
    var input = this.getInputByParisName(name);

    if (!input) {
        return false;
    }

    return this.setValue(input, value);
}

FormHelper.prototype.setValueByAnetName = function(name, value) {
    var input = this.getInputByAnetName(name);

    if (!input) {
        return false;
    }

    return this.setValue(input, value);
}

module.exports = FormHelper;
